import { type ErrorDialogOptions } from "@src/components/apollo/errorprovider/ErrorDialog";
import { createContext } from "react";

interface ErrorContextProps {
    showError: (options: ErrorDialogOptions) => void;
}

const ErrorContext = createContext<ErrorContextProps>({
    showError: () => {
        console.error("ErrorContext not initialized");
    },
});
export default ErrorContext;
